import React, {useEffect} from 'react';
import ReactDOM from 'react-dom';
import {GrowthBook} from "@growthbook/growthbook-react";
import {GrowthBookProvider} from "@growthbook/growthbook-react";
// redux
import {createStore, applyMiddleware, compose} from 'redux';
import {Provider} from 'react-redux';
import {PublicClientApplication} from "@azure/msal-browser";
import {MsalProvider} from "@azure/msal-react";
import reducers from './redux/reducers';
import reduxThunk from 'redux-thunk';
import {msalConfig} from './config/authConfig';

// styles
import './index.css';
import 'font-awesome/css/font-awesome.min.css';
import 'remixicon/fonts/remixicon.css'

import App from './App';

import '@sdk-point/talisis/lib/core/interceptors/axios'

const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;

const enhancer = composeEnhancers(
    applyMiddleware(reduxThunk),
);

const store = createStore(
    reducers,
    enhancer
);

export {store};

const msalInstance = new PublicClientApplication(msalConfig);

const gb = new GrowthBook({
    apiHost: "https://growth-proxy.talisis.com",
    clientKey:process.env.REACT_APP_TOKEN_GROWTHBOOK,
    enableDevMode: true,
    trackingCallback: (experiment, result) => {
        // This is where you would send an event to your analytics provider
        console.log("Viewed Experiment", {
            experimentId: experiment.key,
            variationId: result.key
        });
    },
});

gb.init({streaming: true});

ReactDOM.render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <GrowthBookProvider growthbook={gb}>
                <Provider store={store}>
                    <App/>
                </Provider>
            </GrowthBookProvider>
        </MsalProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

